'use client';

import { VpIcon } from '@vtmn-play/react';
import { CategoryActionCardProps } from './CategoryActionCard.props.tsx';
import ActionCard from '../ActionCard/ActionCard.tsx';
import { categoryIcons } from '@repo/common/config';
import Chip from '../Chip/Chip.tsx';

import './CategoryActionCard.scss';

const CategoryActionCard = ({
  action,
  as,
  categoryType,
  className,
  description,
  i18n = { showDescription: 'Show description' },
  id,
  name = '',
  subtitle,
}: CategoryActionCardProps) => {
  const iconName = categoryType && categoryIcons?.[categoryType];

  return (
    <ActionCard
      action={action}
      as={as}
      className={className}
      i18n={{ showTertiary: i18n.showDescription }}
      id={id}
      illustration={
        iconName ? (
          <div className='category-card-icon'>
            <VpIcon name={iconName} size={48} />
          </div>
        ) : undefined
      }
      primary={
        <div className='category-card-title'>
          <span>{name}</span>
          {i18n?.serviceCountChip && (
            <Chip variant='brand'>{i18n.serviceCountChip}</Chip>
          )}
        </div>
      }
      secondary={<p className='category-card-subtitle'>{subtitle}</p>}
      tertiary={description}
    />
  );
};

export default CategoryActionCard;
